import { Component } from 'react';

import styles from './ConfirmAction.module.css';
import { isTestEnv } from '../../../../../devOpsHelper/DevOps';

export class ConfirmAction extends Component {
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        if (!isTestEnv()) {
            this.setState({ disableInput: true });
            setTimeout(() => {
                this.setState({ disableInput: false });
            }, 500);
        } else {
            this.setState({ disableInput: false });
        }
    }

    handleClick = () => {
        const { onSubmit } = this.props;

        onSubmit();
    };

    render() {
        const { children, ...otherProps } = this.props;

        return (
            <button
                disabled={this.state.disableInput}
                className={styles.ConfirmAction}
                onClick={this.handleClick}
                {...otherProps}
            >
                {children}
            </button>
        );
    }
}
